export enum APPLICATION_TYPE {
  CONVENTIONAL = 'CONVENTIONAL',
  ISLAMIC = 'ISLAMIC',
  ALL = 'ALL',
}
